/**
 * Trade-history API client. Feeds the Trade History table on the
 * symbol pair detail page.
 */

import { api } from "../api";
import type { TradeRow, ListTradesRes } from "@pfh/shared";

export type { TradeRow } from "@pfh/shared";

/** List up to 100 most recent trades for a pair (slug or id). */
export async function listTrades(pairIdOrSlug: string): Promise<TradeRow[]> {
  const res = await api.get<ListTradesRes>(
    `/api/pairs/${encodeURIComponent(pairIdOrSlug)}/trades`,
  );
  return res.trades;
}
